import request from '@/utils/request'
import { normalizeCommunityId } from '@/api/community/communityApi'

// 获取投诉类型详情
export function getComplaintTypeDetail(params) {
  return new Promise((resolve, reject) => {
    const query = { ...params }
    if (Object.prototype.hasOwnProperty.call(query, 'communityId')) {
      query.communityId = normalizeCommunityId(query.communityId)
      if (!query.communityId) {
        delete query.communityId
      }
    }
    request({
      url: '/complaintType.listComplaintType',
      method: 'get',
      params: query
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 更新投诉类型
export function updateComplaintType(data) {
  return new Promise((resolve, reject) => {
    const payload = { ...data }
    if (Object.prototype.hasOwnProperty.call(payload, 'communityId')) {
      payload.communityId = normalizeCommunityId(payload.communityId)
    }
    request({
      url: '/complaintType.updateComplaintType',
      method: 'post',
      data: payload
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取组织树
export function listOrgTree(params) {
  return new Promise((resolve, reject) => {
    const query = { ...params }
    if (Object.prototype.hasOwnProperty.call(query, 'communityId')) {
      query.communityId = normalizeCommunityId(query.communityId)
      if (!query.communityId) {
        delete query.communityId
      }
    }
    request({
      url: '/org.listOrgTree',
      method: 'get',
      params: query
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取员工信息
export function getStaffInfos(params) {
  return new Promise((resolve, reject) => {
    const query = { ...params }
    if (Object.prototype.hasOwnProperty.call(query, 'communityId')) {
      query.communityId = normalizeCommunityId(query.communityId)
      if (!query.communityId) {
        delete query.communityId
      }
    }
    request({
      url: '/query.staff.infos',
      method: 'get',
      params: query
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
